import { NgModule } from '@angular/core';
import * as CryptoTea from 'xxtea';

@NgModule({
  imports: [
  ],
  declarations: [
  ],
  providers: [
  ]
})
export class SemsoEncryptionModule {
  private encryptSecretKey: string = "SemsPrase";

  encrypt(value: string): string {
    try {
      var result = CryptoTea.encrypt(JSON.stringify(value), this.encryptSecretKey).toString();
      result = window.btoa(result);
      result = result
        .replace(/\+/g, '-')
        .replace(/\//g, 'X_')
        .replace(/\=/g, 'Y_');
      return result;
    }
    catch (error) {
      alert('Error encrypting: ' + value + ' => ' + error);
    }
  }

  decrypt(value: string): string {
    try {
      if (this.isNumber(value)) {
        return value;
      }

      value = value
        .replace(/-/g, '+')
        .replace(/X_/g, '/')
        .replace(/Y_/g, '=');

      var result = window.atob(value);
      return CryptoTea.decrypt(result, this.encryptSecretKey);
    }
    catch (error) {
      alert('Error decrypting: ' + value + ' => ' + error);
    }
  }

  isNumber(n): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
}



// WEBPACK FOOTER //
// ./src/app/encryption/encryption.module.ts